import { ShieldCheck, Database, Ban, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const guarantees = [
  {
    icon: ShieldCheck,
    name: "Zéro Risque",
    description: "Essai gratuit, sans carte bancaire, sans engagement.",
  },
  {
    icon: Database,
    name: "Tes Données T'Appartiennent",
    description: "Export libre à tout moment, pas de verrouillage.",
  },
  {
    icon: Ban,
    name: "Zéro Commission",
    description: "Jamais un centime par couvert. Pour toujours.",
  },
  {
    icon: Scale,
    name: "Meilleur Prix",
    description: "Trouvé moins cher à fonctionnalités équivalentes ? Envoie-nous l'offre, on s'aligne.",
  },
];

type GuaranteesProps = {
  heading?: string;
  subheading?: string;
  compact?: boolean;
};

const Guarantees = ({
  heading = "Nos 4 garanties",
  subheading = "Un engagement simple, pour que tu essaies sans hésiter.",
  compact = false,
}: GuaranteesProps) => {
  return (
    <section className={compact ? "py-12 bg-background" : "py-24 bg-background"}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-foreground mb-3">
            {heading}
          </h2>
          {subheading && (
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {subheading}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {guarantees.map((g) => {
            const Icon = g.icon;
            return (
              <Card
                key={g.name}
                className="border-border hover:border-primary/30 transition-colors"
              >
                <CardContent className="p-6 text-center space-y-3">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="font-playfair text-lg font-semibold text-foreground">
                    {g.name}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {g.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Guarantees;
